//product create or update
import product from './product.json'

export const formTitle = (isCreated = true, isUpper = true) => {
    const title = isCreated ? 'Создать товар' : 'Инфо о Товаре'
    return isUpper ? title.toUpperCase() : title
}

export const formKeys = product


//products
import {keys, buttons} from './products.json'

export const tableTitle = (isUpper = true) => isUpper ? 'Товары'.toUpperCase() : 'Товары'


export const tableKeys = (isUpper = true) => isUpper ? keys.map(key => {
    return {
        value: key.value,
        text: key.text.toUpperCase()
    }
}) : keys

export const tableButtons = (isUpper = true) => isUpper ? buttons.map(btn => {
    return {
        route: btn.route,
        name: btn.name.toUpperCase()
    }
}) : buttons
